/**
 * Leaves `/login` once the session is authenticated.
 *
 * The router context must be refreshed *before* either exit path runs. The
 * desktop restore performs a same-document hash `location.replace`, which the
 * router handles in place — the root match is reused, so its `beforeLoad`
 * (and the `authGateState` it puts in context) is never re-evaluated. A
 * restored thread/project route sits under `/_chat`, whose `beforeLoad` reads
 * that context, so a stale `requires-auth` bounces the user straight back to
 * `/login`.
 */
export async function completeLoginAuthNavigation(steps: {
  readonly invalidateRouter: () => Promise<unknown>;
  readonly restoreDesktopRoute: () => boolean;
  readonly navigateHome: () => void;
}): Promise<void> {
  await steps.invalidateRouter();
  if (steps.restoreDesktopRoute()) {
    return;
  }
  steps.navigateHome();
}
